const isNumeric = (c) => {
    const invalidNumber = isNaN(c);
    return !invalidNumber;
};

const numericOnly = (e) => {
    // need to allow backspace, arrow keys, select all, etc.
    if(!isNumeric(e.key)) {
        e.preventDefault();
        return false;
    }
};

const verifyPin = (e) => {
    let $verifyPin = $('#verifyPin'), 
        $pin = $('#newPin'), 
        $pinMatchError = $('#pinMatchFailMsg'), 
        $resetBtn = $('#btnSubmitPinChange');
    if ($verifyPin.val() !== $pin.val()) {
        $pinMatchError.removeClass('hide');
        $resetBtn.attr('disabled', true);
        return;
    }
    $pinMatchError.addClass('hide');
    $resetBtn.attr('disabled', false);
};

const pinCriteriaCheck = (e) => {
    if(e.isDefaultPrevented()) return false;
    let $pin              = $('#newPin'),
        $pinCriteriaError = $('#pinCriteriaFailMsg'),
        pin               = $pin.val(),
        numericCharacter  = new RegExp('[0-9]').test(pin),
        pinLength         = pin.length,
        $resetBtn         = $('#btnSubmitPinReset');
    if (pinLength !== 4 || !numericCharacter) {
        $pinCriteriaError.removeClass('hide');
        $resetBtn.attr('disabled', true);
        return;
    }
    $pinCriteriaError.addClass('hide');
    $resetBtn.attr('disabled', false);
};

export default function () {
    $('#passwordCurrentMatchMsg').addClass('hide');
    $('#pinCriteriaFailMsg').addClass('hide');
    $('#pinMatchFailMsg').addClass('hide');
    //$('#verifyPin,#newPin').keydown(numericOnly);
    $('#verifyPin').keyup(verifyPin);
    $('#newPin').keyup(pinCriteriaCheck);
}